import { Api } from './api';

export class LogsApi {
    private static readonly PATH = '/logs';

    constructor(private readonly m_api: Api) {}

    public async log() { // no action
        return this.m_api.post(LogsApi.PATH, {});
    }
}